import { PieArcDatum, ProvidedProps } from '@visx/shape/lib/shapes/Pie';

import { Data } from './PieArc.types';

interface Props {
  arc: PieArcDatum<Data>;
  pie: ProvidedProps<Data>;
  colors: string[];
  opacity?: number;
}

export const PieArc: React.FC<Props> = ({ arc, pie, colors, opacity = 1 }) => {
  return (
    <g>
      <path
        d={pie.path(arc) ?? ''}
        fill={colors[arc.index]}
        fillOpacity={opacity}
      />
    </g>
  );
};
